<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHinge from "./DesignerQuestionHardwareHinge.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHinge,
            TileQuestion
        ],
        props: {
            title: {
                default() {
                    return 'Select A Hinge'
                }
            }
        },
    }
</script>
